import React from 'react';
import CountryFlagIcon from '@liquidweb-dev/undercurrent/icons/hatScripts/CountryFlag';

const COUNTRY_CODE_MAP = {
	AUSTRALIA: 'au',
	NETHERLANDS: 'nl',
	'UNITED KINGDOM': 'gb',
	'UNITED STATES': 'us',
};

/** @param {Omit<import('@liquidweb-dev/undercurrent/types/svgTypes').CountryFlagProps, 'countryCode'> & { country: string }} props */
const DetermineCountryFlag = ({ country, ...rest }) => {
	if (country) {
		return (
			<CountryFlagIcon
				countryCode={COUNTRY_CODE_MAP[country?.toUpperCase()]}
				{...rest}
			/>
		);
	}
	return null;
};

export default DetermineCountryFlag;
